import * as z from "zod/v4";

export const submitMerchantFeedback = {
  name: "submitMerchantFeedback" as const,
  input: z.object({ comment: z.string().trim().min(1).max(500) }),
  output: z.object({ success: z.literal(true) }),
};
